module.exports = __webpack_public_path__ + "static/media/bracelet.dd8add7f.jpg";